import {NavigationLinkOptions} from '@deere/fuel-react';
import {AnchorLink} from 'components/AnchorLink';
import {useLocation} from 'react-router-dom';
import {AdminReqUserCheck, BillingUserCheck, BulkLoadUserCheck, ScheduledClassesUserCheck} from '../components/UserPermissions';
import {useTranslation} from 'react-i18next';

type CreateDropDownMenuFunc = (label: string, subNavItems: object) => NavigationLinkOptions;

type CreateMenuFunc = (label: string, url: string) => NavigationLinkOptions;

type UseNavigationItemsHook = () => NavigationLinkOptions[];

const useCreateDropDownMenu: CreateDropDownMenuFunc = (label, subNavItems) => {
    const location = useLocation();

    const subNavigationItems = Object.entries(subNavItems).map(([subLabel, url]) => ({
        component: AnchorLink,
        href: url,
        label: subLabel,
        selected: location.pathname === url
    }));

    return {
        label,
        subNavigationItems
    };
};

const useCreateMenu: CreateMenuFunc = (label, url) => {
    const location = useLocation();

    return {
        component: AnchorLink,
        href: url,
        label,
        selected: location.pathname === url
    };
};

const useAdminRequests = (navArr: NavigationLinkOptions[], t: any): void => {
    const adminTab = useCreateDropDownMenu(t('nav.adminRequests'), {
        [t('nav.newRequest')]: '/newadminrequest',
        [t('nav.myRequests')]: '/myadminrequests'
    });

    if (AdminReqUserCheck()) {
        navArr.push(adminTab);
    }
};

const useAddClassRequests = (navArr: NavigationLinkOptions[], t: any): void => {
    const classAdministration: Record<string, string> = {
        [t('nav.classRequests')]: '/requestclass'
    };

    if (BulkLoadUserCheck()) {
        classAdministration[t('nav.bulkClassLoad')] = '/bulkclassloadrequest';
    }
    if (ScheduledClassesUserCheck()) {
        classAdministration[t('nav.scheduledClass')] = '/scheduledclasshistory';
    }

    navArr.push(useCreateDropDownMenu(t('nav.classAdministration'), classAdministration));
};

const useAddBilling = (navArr: NavigationLinkOptions[], t: any): void => {
    const jduBillingTab = useCreateMenu(t('nav.jduBillingInternal'), '/jdubilling');

    // This check needs to be updated for JDU billing admin AD group
    if (BillingUserCheck()) {
        navArr.push(jduBillingTab);
    }
};

export const useNavigationItems: UseNavigationItemsHook = () => {
    const navArr: NavigationLinkOptions[] = [];
    const {t} = useTranslation();

    useAdminRequests(navArr, t);
    useAddClassRequests(navArr, t);
    useAddBilling(navArr, t);

    return navArr;
};
